import React, { useEffect, useState } from 'react';
import { LiviaLogo } from './logo';
import { SelectField } from '../select';
import { getScenarios } from '../../actions/getScenarios';
import { useLiv } from '../../context/liv';
import { getFirstMessages, getSelectScenarioMessage } from '../../actions/getLanguages';
import clsx from 'clsx';
import { postExchange } from '../../actions/postExchange';

const ActionList = ({ message, actions, onClick }) => (
  <div className="flex flex-col items-center justify-center my-4 w-3/4">
    {message && <span className="text-lg text-fond text-white my-2">{message}</span>}
    <div className="flex flex-wrap justify-center gap-2">
      {actions.map((a) => (
        <button
          key={a.value}
          onClick={() => onClick(a)}
          className={clsx(
            'px-2 py-1 mt-2 rounded border transition-colors duration-150 ease-in-out opacity-70 bg-transparent text-white border-white hover:bg-primary whitespace-nowrap',
          )}
        >
          {a.label}
        </button>
      ))}
    </div>
  </div>
);

const ScenarioList = ({ scenarios, language, startChat }) => {
  const { askId, setAskId } = useLiv();
  const [startChatScenario, setStartChatScenario] = useState(false);
  const filteredScenarios = scenarios.filter((s) => s.language === language);
  const scenarioMessage = getSelectScenarioMessage()[language];

  useEffect(() => {
    if (startChatScenario) {
      startChat({ message: '.', language: language });
    }
  }, [askId]);

  return (
    language &&
    filteredScenarios.length > 0 && (
      <ActionList
        message={scenarioMessage}
        actions={filteredScenarios}
        onClick={(s) => {
          postExchange(
            {
              scenario: s.value,
              language: language,
            },
            {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              'Content-Type': 'application/json',
            },
          ).then((data) => {
            setStartChatScenario(true);
            setAskId(data.thread_id);
          });
        }}
      />
    )
  );
};

const HelloView = ({ startChat }) => {
  const { setLanguage, language, languages } = useLiv(); // Access language and languages from context
  const [scenarii, setScenarii] = useState([]);
  const [displayScenario, setDisplayScenario] = useState(false);

  useEffect(() => {
    getScenarios()
      .then((res) => {
        setScenarii(
          res.results.map((s) => ({
            value: s.id,
            label: s.name,
            isScenario: true,
            language: s.language,
          })),
        );
      })
      .catch(() => setScenarii([]));
  }, []);

  const firstMessage = getFirstMessages()[language];

  const actions = [
    { value: 'scenario', label: '🎬 Scénarios' },
    {
      value: 'imagine',
      label: "💬 Imaginer l'avenir",
      message: 'Livia, comment sera le monde dans 50 ans ?',
    },
    {
      value: 'football',
      label: '⚽ Parler du Sporting',
      message: 'Livia, quand-est ce que le sporting sera en ligue des champions ?',
    },
    { value: 'weather', label: "🌤️ Il fait beau aujourd'hui", message: 'Enfin du beau temps !' },
  ];

  return (
    <>
      <LiviaLogo />
      <SelectField
        defaultValue={languages.find((l) => l.value === language)}
        options={languages}
        onChange={(option) => setLanguage(option.value)}
        className="mb-4 w-full max-w-xs"
      />
      <h2 className="text-bold text-white text-xl sm:text-2xl mt-6 sm:mt-12 text-center">
        {firstMessage}
      </h2>
      <>
        {!displayScenario ? (
          <ActionList
            message=""
            actions={actions}
            onClick={(a) => {
              if (a.value === 'scenario') {
                setDisplayScenario(true);
              } else startChat({ message: a.message, language: language });
            }}
          />
        ) : (
          <ScenarioList scenarios={scenarii} language={language} startChat={startChat} />
        )}
      </>
    </>
  );
};

export default HelloView;
